<h3 class="titulo" mat-dialog-title>{{ data.titulo }}</h3>
<div mat-dialog-content>
  <p>{{ data.mensagem }}</p>

  <div class="btn-bar">
    <button
      mat-raised-button
      *ngFor="let opcao of data.opcoes"
      (click)="opcao.action()"
      color="{{ opcao.cor }}"
    >
      {{ opcao.descricao }}
    </button>
  </div>
</div>
